import { Box, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { ConsensusMode } from '../../types';

export const CONSENSUS_CONTROL_LABEL: Record<ConsensusMode, string> = {
  strict: 'Strict (2+)',
  lenient: 'Lenient (1+)',
  inclusive: 'Inclusive (1+)',
  any: 'Any label',
};

export const DEFAULT_CONSENSUS_MODE: ConsensusMode = 'inclusive';

interface ConsensusModeToggleProps {
  value: ConsensusMode;
  onChange: (next: ConsensusMode) => void;
  includeAny?: boolean;
  compact?: boolean;
}

const ConsensusModeToggle: React.FC<ConsensusModeToggleProps> = ({
  value,
  onChange,
  includeAny,
  compact,
}) => {
  return (
    <Box
      sx={{
        mt: compact ? 0 : 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Consensus
      </Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={value}
        onChange={(_e, val: ConsensusMode | null) => {
          if (val !== null) onChange(val);
        }}
        sx={{
          flexWrap: 'wrap',
          '& .MuiToggleButton-root': { whiteSpace: 'nowrap', px: 1.2, py: 0.25 },
        }}
      >
        <Tooltip title="2+ labellers agree on the same label and no labeller (explicit or implicit) disagrees.">
          <ToggleButton value="strict">{CONSENSUS_CONTROL_LABEL.strict}</ToggleButton>
        </Tooltip>
        <Tooltip title="A single labeller's vote counts as long as no labeller (explicit or implicit) disagrees.">
          <ToggleButton value="lenient">{CONSENSUS_CONTROL_LABEL.lenient}</ToggleButton>
        </Tooltip>
        <Tooltip title="A single labeller's vote counts as long as no labeller explicitly disagrees.">
          <ToggleButton value="inclusive">{CONSENSUS_CONTROL_LABEL.inclusive}</ToggleButton>
        </Tooltip>
        {includeAny && (
          <Tooltip title="Every distinct human label is compared to the AI mark, even when labellers conflict. Surfaces each disagreeing label separately.">
            <ToggleButton value="any">{CONSENSUS_CONTROL_LABEL.any}</ToggleButton>
          </Tooltip>
        )}
      </ToggleButtonGroup>
    </Box>
  );
};

export default ConsensusModeToggle;
